<template>
  <div class="context-menu">
    <!-- Add To Canned Responses -->
    <woot-modal
      v-if="isCannedResponseModalOpen && enabledOptions['cannedResponse']"
      :show.sync="isCannedResponseModalOpen"
      :on-close="hideCannedResponseModal"
    >
      <add-canned-modal
        :response-content="plainTextContent"
        :on-close="hideCannedResponseModal"
      />
    </woot-modal>
    <!-- Translate Content -->
    <translate-modal
      v-if="showTranslateModal"
      :content="messageContent"
      :content-attributes="contentAttributes"
      @close="onCloseTranslateModal"
    />
    <!-- Confirm Deletion -->
    <woot-delete-modal
      v-if="showDeleteModal"
      class="context-menu--delete-modal"
      :show.sync="showDeleteModal"
      :on-close="closeDeleteModal"
      :on-confirm="confirmDeletion"
      :title="$t('CONVERSATION.CONTEXT_MENU.DELETE_CONFIRMATION.TITLE')"
      :message="$t('CONVERSATION.CONTEXT_MENU.DELETE_CONFIRMATION.MESSAGE')"
      :confirm-text="$t('CONVERSATION.CONTEXT_MENU.DELETE_CONFIRMATION.DELETE')"
      :reject-text="$t('CONVERSATION.CONTEXT_MENU.DELETE_CONFIRMATION.CANCEL')"
    />
    <span
      v-if="showTriggerButton"
      class="material-symbols-outlined text-gray-500 text-[24px]/[24px] cursor-pointer rounded-[4px] hover:bg-gray-100 select-none"
      @click="handleOpen"
    >
      more_vert
    </span>
    <woot-context-menu
      v-if="isOpen && !isCannedResponseModalOpen"
      :x="contextMenuPosition.x"
      :y="contextMenuPosition.y"
      @close="handleClose"
    >
      <div class="menu-container">
        <menu-item
          v-if="enabledOptions['replyTo']"
          :option="{
            icon: 'reply',
            label: $t('CONVERSATION.CONTEXT_MENU.REPLY_TO'),
          }"
          variant="icon"
          @click="handleReplyTo"
        />
        <menu-item
          v-if="enabledOptions['copy']"
          :option="{
            icon: 'content_copy',
            label: $t('CONVERSATION.CONTEXT_MENU.COPY'),
          }"
          variant="icon"
          @click="handleCopy"
        />
        <!-- <menu-item
          :option="{
            icon: 'translate',
            label: $t('CONVERSATION.CONTEXT_MENU.TRANSLATE'),
          }"
          variant="icon"
          @click="handleTranslate"
        /> -->
        <menu-item-with-submenu
          v-if="messageContent && chatGPTActivated && !hideTranslateOption"
          :option="translateOption"
          variant="icon"
        >
          <menu-item
            v-for="(option, i) in translateOption.options"
            :key="i"
            :option="option"
            @click="handleTranslate(option.key)"
          />
        </menu-item-with-submenu>
        <menu-item
          :option="{
            icon: 'link',
            label: $t('CONVERSATION.CONTEXT_MENU.COPY_PERMALINK'),
          }"
          variant="icon"
          @click="copyLinkToMessage"
        />
        <menu-item
          v-if="
            enabledOptions['cannedResponse'] &&
            hasCreatePermission('Canned Responses')
          "
          :option="{
            icon: 'chat_add_on',
            label: $t('CONVERSATION.CONTEXT_MENU.CREATE_A_CANNED_RESPONSE'),
          }"
          variant="icon"
          @click="showCannedResponseModal"
        />
        <menu-item
          v-if="enabledOptions['remoteAssignFile']"
          :option="{
            icon: 'attach',
            label: $t('PLATFORM.BAFI_ASSIGN_FILE'),
          }"
          variant="icon"
          @click="handleRemoteAssignFile"
        />
        <div v-if="enabledOptions['delete']" class="danger-item">
          <menu-item
            :option="{
              icon: 'delete',
              label: $t('CONVERSATION.CONTEXT_MENU.DELETE'),
              iconColor: 'text-[#EF4444]',
              labelColor: 'text-[#DC2626]',
            }"
            variant="icon"
            @click="openDeleteModal"
          />
        </div>
        <div
          v-if="d99dEnables.loading"
          class="spinner"
          :style="{ height: 3.2 * (menuPosition === 'left' ? 2 : 1) + 'rem' }"
        />
        <menu-item
          v-if="d99dEnables.showLike"
          :option="{
            icon: '',
            label: $t('CONVERSATION.CONTEXT_MENU.LIKE'),
          }"
          variant="clear"
          @click="handleD99dSelection('like')"
        />
        <menu-item
          v-if="d99dEnables.showUnlike"
          :option="{
            icon: '',
            label: $t('CONVERSATION.CONTEXT_MENU.UNLIKE'),
          }"
          variant="clear"
          @click="handleD99dSelection('unlike')"
        />
        <menu-item
          v-if="d99dEnables.showHide"
          :option="{
            icon: '',
            label: $t('CONVERSATION.CONTEXT_MENU.HIDE'),
          }"
          variant="clear"
          @click="handleD99dSelection('hide')"
        />
        <menu-item
          v-if="d99dEnables.showUnhide"
          :option="{
            icon: '',
            label: $t('CONVERSATION.CONTEXT_MENU.UNHIDE'),
          }"
          variant="clear"
          @click="handleD99dSelection('unhide')"
        />
        <!-- d99d 99hub — hide/unhide a Facebook page comment -->
        <menu-item
          v-if="enabledOptions['hubHide'] && !contentAttributes.is_hidden"
          :option="{
            icon: 'eye-hide',
            label: $t('HUB.FB_COMMENT.HIDE'),
            info: $t('HUB.FB_COMMENT.HIDE_INFO'),
          }"
          variant="icon"
          @click="handleD99dSelection('hubHide')"
        />
        <menu-item
          v-if="enabledOptions['hubHide'] && contentAttributes.is_hidden"
          :option="{
            icon: 'eye-show',
            label: $t('HUB.FB_COMMENT.UNHIDE'),
          }"
          variant="icon"
          @click="handleD99dSelection('hubUnhide')"
        />
        <menu-item
          v-if="d99dEnables.showPrivateReply"
          :option="{
            icon: '',
            label: $t('CONVERSATION.CONTEXT_MENU.PRIVATE_REPLY'),
          }"
          variant="clear"
          @click="handleD99dSelection('private_reply')"
        />
        <menu-item
          v-if="
            enabledOptions['scopeTiktok'] && !message.content_attributes.hide
          "
          :option="{
            icon: '',
            label: $t(
              `CONVERSATION.CONTEXT_MENU.${
                message.content_attributes.liked ? 'UNLIKE' : 'LIKE'
              }`
            ),
          }"
          variant="clear"
          @click="
            handleD99dSelection(
              message.content_attributes.liked ? 'tiktokUnlike' : 'tiktokLike'
            )
          "
        />
        <menu-item
          v-if="enabledOptions['scopeTiktok']"
          :option="{
            icon: '',
            label: $t(
              `CONVERSATION.CONTEXT_MENU.${
                message.content_attributes.hide ? 'UNHIDE' : 'HIDE'
              }`
            ),
          }"
          variant="clear"
          @click="
            handleD99dSelection(
              message.content_attributes.hide ? 'tiktokUnhide' : 'tiktokHide'
            )
          "
        />
      </div>
      <!--        d99d-->
    </woot-context-menu>
  </div>
</template>
<script>
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import AddCannedModal from 'dashboard/routes/dashboard/settings/canned/AddCanned.vue';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import { conversationUrl, frontendURL } from '../../../helper/URLHelper';
import { ACCOUNT_EVENTS } from '../../../helper/AnalyticsHelper/events';
import TranslateModal from 'dashboard/components/widgets/conversation/bubble/TranslateModal.vue';
import MenuItem from '../../../components/widgets/conversation/contextMenu/menuItem.vue';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import MenuItemWithSubmenu from '../../../components/widgets/conversation/contextMenu/menuItemWithSubmenu.vue';

export default {
  components: {
    AddCannedModal,
    TranslateModal,
    MenuItem,
    MenuItemWithSubmenu,
  },
  mixins: [alertMixin, clickaway, messageFormatterMixin, hasPermissionMixin],
  props: {
    message: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    enabledOptions: {
      type: Object,
      default: () => ({}),
    },
    contextMenuPosition: {
      type: Object,
      default: () => ({}),
    },
    d99dEnables: {
      type: Object,
      default: () => {},
    },
    hideTranslateOption: {
      type: Boolean,
      default: false,
    },
    showTriggerButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isCannedResponseModalOpen: false,
      showTranslateModal: false,
      showDeleteModal: false,
      translateOption: {
        key: 'translate',
        label: this.$t('CONVERSATION.CONTEXT_MENU.TRANSLATE'),
        icon: 'translate',
        options: [
          {
            key: 'en',
            label: 'English',
          },
          {
            key: 'el',
            label: 'Greek',
          },
          {
            key: 'he',
            label: 'Hebrew',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      currentAccountId: 'getCurrentAccountId',
    }),
    plainTextContent() {
      return this.getPlainText(this.messageContent);
    },
    conversationId() {
      return this.message.conversation_id;
    },
    messageId() {
      return this.message.id;
    },
    messageContent() {
      return this.message.content;
    },
    contentAttributes() {
      return this.message.content_attributes;
    },
    chatGPTActivated() {
      const account = this.getAccount(this.currentAccountId);
      return account.chat_gpt;
    },
  },
  methods: {
    async copyLinkToMessage() {
      const fullConversationURL =
        window.chatwootConfig.hostURL +
        frontendURL(
          conversationUrl({
            id: this.conversationId,
            accountId: this.currentAccountId,
          })
        );
      await copyTextToClipboard(
        `${fullConversationURL}?messageId=${this.messageId}`
      );
      this.showAlert(this.$t('CONVERSATION.CONTEXT_MENU.LINK_COPIED'));
      this.handleClose();
    },
    async handleCopy() {
      await copyTextToClipboard(this.plainTextContent);
      this.showAlert(this.$t('CONTACT_PANEL.COPY_SUCCESSFUL'));
      this.handleClose();
    },
    showCannedResponseModal() {
      this.$track(ACCOUNT_EVENTS.ADDED_TO_CANNED_RESPONSE);
      this.isCannedResponseModalOpen = true;
    },
    hideCannedResponseModal() {
      this.isCannedResponseModalOpen = false;
      this.handleClose();
    },
    handleOpen(e) {
      this.$emit('open', e);
    },
    handleClose(e) {
      this.$emit('close', e);
    },
    handleRemoteAssignFile() {
      // todo use bus from here
      this.$emit('remoteAssignFile');
      this.handleClose();
    },
    handleTranslate(targetLanguage) {
      this.handleClose();
      this.$emit('translate', targetLanguage);
      // this.showTranslateModal = true;
    },
    handleReplyTo() {
      this.$emit('replyTo');
      this.handleClose();
    },
    onCloseTranslateModal() {
      this.showTranslateModal = false;
    },
    openDeleteModal() {
      this.handleClose();
      this.showDeleteModal = true;
    },
    async confirmDeletion() {
      try {
        await this.$store.dispatch('deleteMessage', {
          conversationId: this.conversationId,
          messageId: this.messageId,
        });
        this.showAlert(this.$t('CONVERSATION.SUCCESS_DELETE_MESSAGE'));
        this.handleClose();
      } catch (error) {
        this.showAlert(this.$t('CONVERSATION.FAIL_DELETE_MESSSAGE'));
      }
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    // d99d
    handleD99dSelection(option) {
      this.$emit('d99dSelect', option);
    },
    // .
  },
};
</script>
<style lang="scss" scoped>
.menu-container {
  @apply bg-white dark:bg-slate-900 shadow-xl rounded-lg;
  min-width: 175px;

  hr:first-child {
    @apply hidden;
  }

  hr {
    @apply my-0 border-b border-solid border-slate-100 dark:border-slate-800;
  }

  ::v-deep .menu {
    @apply flex items-center gap-1 rounded-none cursor-pointer;
    width: 100%;
    height: 28px;
    padding: 6px 12px;

    .menu-label {
      font-size: 14px !important;
    }

    &:hover {
      @apply bg-green-50 dark:bg-slate-800 text-[#164B35] dark:text-slate-200;

      .material-symbols-outlined,
      .menu-label {
        @apply text-[#164B35] dark:text-slate-200;
      }
    }

    .menu-icon {
      @apply flex-shrink-0 text-slate-600 dark:text-slate-300;
    }

    .menu-label {
      @apply m-0 text-base leading-6 text-slate-600 dark:text-slate-300;
    }
  }

  ::v-deep .menu-with-submenu {
    padding: 6px 12px;
  }
}

.danger-item {
  ::v-deep .menu {
    .menu-icon,
    .menu-label {
      @apply text-red-600 dark:text-red-500;
    }

    &:hover {
      @apply bg-red-50 dark:bg-red-900/20;

      .material-symbols-outlined,
      .menu-label {
        @apply text-red-600 dark:text-red-500;
      }
    }
  }
}

.context-menu--delete-modal {
  ::v-deep {
    .modal-container {
      @apply max-w-[30rem];

      h2 {
        @apply font-medium text-base;
      }
    }

    .modal-footer {
      @apply pt-4 pb-8 px-8;
    }
  }
}
</style>
